$(function () {
	if ($('.jq_dropdown').length) {
		$(window).on('load resize', function() {
			var maxWidth = $(window).width();

			$('.jq_dropdown').each(function() {
				var $el = $(this);

				$el.removeAttr('data-align');

				if ($el.offset().left + $el.outerWidth() >= maxWidth) {
					$el.attr('data-align', 'right');
				}
			});
		});
	}
});
